import axios from 'axios';

export function connectNewDomainToUser({ domain, user }) {
    return axios({
        method: 'post',
        url: '/api/v1/domain/',
        withCredentials: true,
        data: {
            domain,
            user,
        }
    })
        .then((response) => response.data)
        .catch((error) => error.response)
}

export function deleteDomain({ id }) {
    return axios({
        method: 'delete',
        url: `/api/v1/domain/${id}`,
        withCredentials: true,
    })
        .then((response) => response.data)
        .catch((error) => error.response)
}

export function getListDomain() {
    return axios({
        method: 'get',
        url: '/api/v1/domain/',
        withCredentials: true,
    })
        .then((response) => response.data)
        .catch((error) => error.response)
}



// WEBPACK FOOTER //
// ./app/services/domains.js